import type { ArenaBox, Vec3 } from "@arena/shared";

/** Slab test: does the segment a→b cross the box inflated by `pad`? */
export function segmentHitsBox(a: Vec3, b: Vec3, box: ArenaBox, pad = 0): boolean {
  let tMin = 0;
  let tMax = 1;
  for (const axis of ["x", "y", "z"] as const) {
    const start = a[axis];
    const delta = b[axis] - start;
    const lo = box.min[axis] - pad;
    const hi = box.max[axis] + pad;
    if (Math.abs(delta) < 1e-9) {
      if (start < lo || start > hi) return false;
      continue;
    }
    let t1 = (lo - start) / delta;
    let t2 = (hi - start) / delta;
    if (t1 > t2) [t1, t2] = [t2, t1];
    tMin = Math.max(tMin, t1);
    tMax = Math.min(tMax, t2);
    if (tMin > tMax) return false;
  }
  return true;
}
